"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = modals;

var _ModalsActionTypes = require("../constants/action-types/ModalsActionTypes");

var actionTypes = _interopRequireWildcard(_ModalsActionTypes);

var _ChallengeData = require("../constants/ChallengeData");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

var initialState = {
  modalType: null,
  modalProps: {}
};

function modals() {
  var modals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case actionTypes.SHOW_MODAL:
      return showModal(modals, payload);

    case actionTypes.HIDE_MODAL:
      return hideModal(modals);

    case actionTypes.HANDLE_INPUT_ERROR:
      return handleInputError(modals, payload);

    case actionTypes.SET_FILE_OPTIONS:
      return setFileOptions(modals, payload);

    case actionTypes.SET_FILE_OPTIONS_ERROR:
      return setFileOptionsError(modals, payload);

    case actionTypes.SET_CHOSEN:
      return setChosen(modals, payload);

    case actionTypes.FILTER_CHARACTERS:
      return filterCharacters(modals, payload);

    default:
      return modals;
  }
}

var showModal = function showModal(modals, _ref2) {
  var modalType = _ref2.modalType,
      _ref2$modalProps = _ref2.modalProps,
      modalProps = _ref2$modalProps === undefined ? {} : _ref2$modalProps;
  return _extends({}, modals, {
    modalType: modalType,
    modalProps: modalProps
  });
};

var hideModal = function hideModal() {
  return initialState;
};

var setFileOptions = function setFileOptions(modals, _ref3) {
  var _ref3$files = _ref3.files,
      files = _ref3$files === undefined ? {} : _ref3$files,
      type = _ref3.type;
  var options = [];
  var Prefix = files.Prefix,
      CommonPrefixes = files.CommonPrefixes,
      Contents = files.Contents;
  var optionsType = type === _ChallengeData.CHARACTER_BUILDING_CHALLENGE ? "character" : "folder";
  options.push.apply(options, _toConsumableArray(CommonPrefixes.map(function (c) {
    return c.Prefix.replace(Prefix, "").replace("/", "");
  })));
  options.push.apply(options, _toConsumableArray(Contents.map(function (c) {
    return c.Prefix.replace(Prefix, "").replace("/", "");
  })));
  return _extends({}, modals, {
    modalProps: {
      options: options,
      optionsType: optionsType
    }
  });
};

var setFileOptionsError = function setFileOptionsError(modals) {
  return _extends({}, modals, {
    modalProps: {
      error: "Couldn't load the options :("
    }
  });
};

var handleInputError = function handleInputError(modals, _ref4) {
  var err = _ref4.err;
  return _extends({}, modals, {
    modalProps: _extends({}, modals.modalProps, {
      inputError: err
    })
  });
};

var filterCharacters = function filterCharacters(modals, _ref5) {
  var search = _ref5.search;
  var found = modals.modalProps.options.includes(search);
  return _extends({}, modals, {
    modalProps: _extends({}, modals.modalProps, {
      inputError: null,
      filter: search,
      chosen: found ? search : null
    })
  });
};

var setChosen = function setChosen(modals, _ref6) {
  var chosen = _ref6.chosen;
  return _extends({}, modals, {
    modalProps: _extends({}, modals.modalProps, {
      chosen: chosen,
      filter: chosen
    })
  });
};